function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgMoney = function SvgMoney(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 509.936 509.936",
    style: {
      enableBackground: "new 0 0 509.936 509.936"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#719C40"
    },
    d: "M477.952,405.912H75.312c-17.68,0-32-14.32-32-32V179.336c0-17.68,14.32-32,32-32h402.624 c17.68,0,32,14.32,32,32v194.592C509.952,391.592,495.616,405.912,477.952,405.912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7FB241"
    },
    d: "M434.64,362.6H32c-17.664,0-32-14.32-32-32V136.024c0-17.68,14.336-32,32-32h402.624 c17.68,0,32,14.32,32,32v194.592C466.64,348.28,452.304,362.6,434.64,362.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8BC540"
    },
    d: "M29.168,269.432v-72.24c35.344,0,64-28.656,64-64h280.304c0,35.344,28.656,64,64,64v72.24 c-35.344,0-64,28.656-64,64H93.168C93.168,298.088,64.512,269.432,29.168,269.432z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#7FB241"
    },
    cx: 233.328,
    cy: 233.304,
    rx: 77.648,
    ry: 109.616
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7FB241"
    },
    cx: 101.904,
    cy: 233.304,
    r: 33.808
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7FB241"
    },
    cx: 364.752,
    cy: 233.304,
    r: 33.808
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M228.496,268.424v-28.896c-9.008-2.576-15.616-6.464-19.824-11.68 c-4.208-5.216-6.304-11.552-6.304-18.992c0-7.536,2.384-13.872,7.136-18.992c4.752-5.12,11.088-8.08,18.992-8.864v-6.832h10V181 c7.312,0.88,13.12,3.36,17.44,7.472c4.32,4.112,7.072,9.616,8.272,16.512l-17.44,2.272c-1.056-5.424-3.808-9.104-8.272-11.024v26.96 c11.024,2.992,18.544,6.864,22.544,11.616s6,10.864,6,18.304c0,8.32-2.512,15.328-7.552,21.024s-12.032,9.184-20.992,10.48v7.824 h-10v-7.472c-7.952-0.96-14.416-3.936-19.376-8.896s-8.128-11.968-9.52-21.024l18-1.936c0.736,3.68,2.112,6.848,4.144,9.52 C223.76,265.304,226.016,267.224,228.496,268.424z M228.496,196.024c-2.72,0.912-4.88,2.48-6.48,4.688 c-1.616,2.208-2.416,4.64-2.416,7.312c0,2.432,0.736,4.704,2.208,6.784s3.696,3.776,6.688,5.072V196.024z M238.496,269.384 c3.44-0.64,6.256-2.24,8.416-4.784c2.16-2.56,3.248-5.552,3.248-8.992c0-3.072-0.912-5.728-2.72-7.968 c-1.808-2.224-4.784-3.936-8.928-5.136v26.88H238.496z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoney, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/money.0b532f49.svg";
export { ForwardRef as ReactComponent };